import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.signup');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-signup',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.signup/view.scss */
:host {
  display: block;
}

* {
  box-sizing: border-box;
}

.signup-page {
  min-height: 100vh;
  min-height: 100dvh;
  padding: 24px;
  color: #172033;
  background: radial-gradient(circle at 8% 8%, rgba(124, 58, 237, 0.12), transparent 28%), radial-gradient(circle at 92% 92%, rgba(225, 29, 72, 0.09), transparent 28%), #f8f7fb;
}

.signup-shell {
  display: grid;
  grid-template-columns: minmax(390px, 0.82fr) minmax(560px, 1.18fr);
  width: min(1240px, 100%);
  min-height: calc(100vh - 48px);
  min-height: calc(100dvh - 48px);
  margin: 0 auto;
  overflow: hidden;
  border: 1px solid rgba(221, 214, 254, 0.8);
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 30px 80px rgba(45, 35, 72, 0.13);
}

.signup-intro {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  padding: 46px 48px 38px;
  overflow: hidden;
  color: #fff;
  background: radial-gradient(circle at 85% 14%, rgba(251, 113, 133, 0.68), transparent 26%), radial-gradient(circle at 4% 92%, rgba(255, 255, 255, 0.13), transparent 28%), linear-gradient(155deg, #4c1d95 0%, #6d28d9 48%, #9f1239 120%);
}

.signup-intro::before,
.signup-intro::after {
  position: absolute;
  content: "";
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 50%;
}

.signup-intro::before {
  top: -150px;
  right: -160px;
  width: 420px;
  height: 420px;
}

.signup-intro::after {
  right: -80px;
  bottom: -100px;
  width: 280px;
  height: 280px;
}

.brand-link,
.mobile-brand {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  gap: 11px;
  width: fit-content;
  color: inherit;
  font-size: 21px;
  text-decoration: none;
}

.brand-link strong,
.mobile-brand strong {
  font-weight: 900;
  letter-spacing: -0.02em;
}

.brand-mark {
  position: relative;
  width: 31px;
  height: 31px;
  flex: 0 0 auto;
}

.brand-mark i {
  position: absolute;
  width: 13px;
  height: 13px;
  border: 2px solid currentColor;
  border-radius: 999px;
}

.brand-mark i:nth-child(1) {
  top: 0;
  left: 3px;
}

.brand-mark i:nth-child(2) {
  top: 3px;
  right: 0;
}

.brand-mark i:nth-child(3) {
  right: 3px;
  bottom: 0;
}

.brand-mark i:nth-child(4) {
  bottom: 3px;
  left: 0;
}

.intro-copy {
  position: relative;
  z-index: 1;
  margin-top: 78px;
}

.eyebrow,
.step-label {
  margin: 0 0 12px;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.13em;
  text-transform: uppercase;
}

.eyebrow {
  color: #fda4af;
}

.intro-copy h1 {
  margin: 0;
  color: #fff;
  font-size: clamp(34px, 3vw, 46px);
  font-weight: 900;
  line-height: 1.2;
  letter-spacing: -0.04em;
}

.intro-copy > p:last-child {
  max-width: 390px;
  margin: 22px 0 0;
  color: rgba(255, 255, 255, 0.74);
  font-size: 14px;
  line-height: 1.75;
}

.benefit-list {
  position: relative;
  z-index: 1;
  display: grid;
  gap: 17px;
  padding: 0;
  margin: 42px 0 34px;
  list-style: none;
}

.benefit-list li {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  gap: 13px;
  align-items: center;
}

.benefit-icon {
  display: grid;
  place-items: center;
  width: 38px;
  height: 38px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 11px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.benefit-icon svg {
  width: 18px;
  height: 18px;
}

.benefit-icon.violet {
  color: #ddd6fe;
}

.benefit-icon.rose {
  color: #fecdd3;
}

.benefit-icon.amber {
  color: #fde68a;
}

.benefit-list strong,
.benefit-list small {
  display: block;
}

.benefit-list strong {
  color: #fff;
  font-size: 13px;
  font-weight: 800;
}

.benefit-list small {
  margin-top: 3px;
  color: rgba(255, 255, 255, 0.62);
  font-size: 11px;
  line-height: 1.45;
}

.mini-preview {
  position: relative;
  z-index: 1;
  margin-top: auto;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 0 20px 45px rgba(22, 9, 45, 0.2);
  backdrop-filter: blur(18px);
}

.preview-head {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.preview-head > span {
  width: 7px;
  height: 7px;
  margin-right: 5px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.4);
}

.preview-head strong {
  margin-left: auto;
  color: rgba(255, 255, 255, 0.76);
  font-size: 11px;
  font-weight: 800;
}

.preview-content {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 7px;
  padding: 14px;
}

.preview-date {
  position: relative;
  display: grid;
  place-items: center;
  min-height: 58px;
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.68);
}

.preview-date.active {
  color: #4c1d95;
  background: #fff;
}

.preview-date small,
.preview-date b {
  display: block;
}

.preview-date small {
  font-size: 9px;
}

.preview-date b {
  font-size: 14px;
}

.preview-date i {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #8b5cf6;
}

.preview-date i.rose {
  background: #fda4af;
}

.preview-date i.amber {
  background: #fbbf24;
}

.signup-form-area {
  align-self: center;
  width: min(590px, 100%);
  padding: 46px 54px 38px;
  margin: 0 auto;
}

.mobile-brand {
  display: none;
  margin-bottom: 30px;
  color: #6d28d9;
}

.form-header {
  margin-bottom: 28px;
}

.step-label {
  color: #e11d48;
}

.form-header h2 {
  margin: 0;
  color: #111827;
  font-size: 30px;
  font-weight: 900;
  letter-spacing: -0.035em;
}

.form-header > p:last-child {
  margin: 9px 0 0;
  color: #64748b;
  font-size: 13px;
}

.signup-form,
.form-grid {
  display: grid;
}

.signup-form {
  gap: 22px;
}

.form-grid {
  grid-template-columns: minmax(0, 1fr);
  gap: 18px 14px;
}

.field-wide {
  grid-column: auto;
}

.field-group label {
  display: block;
  margin-bottom: 7px;
  color: #334155;
  font-size: 12px;
  font-weight: 800;
}

.field-group label em {
  margin-left: 6px;
  color: #94a3b8;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
}

.input-action-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
}

.field-group input {
  display: block;
  width: 100%;
  height: 46px;
  padding: 0 13px;
  border: 1px solid #d8dee9;
  border-radius: 8px;
  outline: none;
  color: #172033;
  font-family: inherit;
  font-size: 13px;
  background: #fff;
  transition: border-color 150ms ease, box-shadow 150ms ease, background 150ms ease;
}

.field-group input::placeholder {
  color: #a1aab9;
}

.field-group input:focus {
  border-color: #8b5cf6;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.12);
}

.field-action-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 88px;
  height: 46px;
  padding: 0 13px;
  border: 1px solid #c4b5fd;
  border-radius: 8px;
  color: #6d28d9;
  font-family: inherit;
  font-size: 11px;
  font-weight: 900;
  white-space: nowrap;
  background: #f5f3ff;
  transition: border-color 150ms ease, color 150ms ease, background 150ms ease;
}

.field-action-button:hover:not(:disabled) {
  border-color: #7c3aed;
  color: #fff;
  background: #7c3aed;
}

.field-action-button:disabled {
  cursor: default;
  opacity: 0.62;
}

.field-group > small,
.match-message {
  display: block;
  margin-top: 6px;
  color: #94a3b8;
  font-size: 10px;
  line-height: 1.4;
}

.field-group > .field-status.success {
  color: #16a34a;
  font-weight: 800;
}

.field-group > .field-status.error {
  color: #dc2626;
  font-weight: 800;
}

.password-input {
  position: relative;
}

.password-input input {
  padding-right: 44px;
}

.password-input button {
  position: absolute;
  top: 50%;
  right: 8px;
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 0;
  border-radius: 7px;
  color: #94a3b8;
  background: transparent;
  transform: translateY(-50%);
}

.password-input button:hover {
  color: #6d28d9;
  background: #f5f3ff;
}

.password-input svg {
  width: 17px;
  height: 17px;
}

.strength-row {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-top: 7px;
}

.strength-bars {
  display: grid;
  grid-template-columns: repeat(3, 30px);
  gap: 4px;
}

.strength-bars i {
  height: 3px;
  border-radius: 99px;
  background: #e5e7eb;
}

.strength-bars[data-score="1"] i:nth-child(1) {
  background: #f59e0b;
}

.strength-bars[data-score="2"] i:nth-child(-n+2) {
  background: #8b5cf6;
}

.strength-bars[data-score="3"] i {
  background: #10b981;
}

.strength-row small {
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
}

.match-message.success {
  color: #059669;
}

.match-message.error {
  color: #e11d48;
}

.agreement {
  display: grid;
  grid-template-columns: 17px minmax(0, 1fr);
  gap: 10px;
  align-items: start;
  padding: 13px 14px;
  border: 1px solid #ece8f3;
  border-radius: 9px;
  color: #475569;
  font-size: 11px;
  line-height: 1.5;
  background: #faf9fc;
  cursor: pointer;
}

.agreement input {
  width: 16px;
  height: 16px;
  margin: 1px 0 0;
  accent-color: #7c3aed;
}

.agreement small {
  display: block;
  margin-top: 2px;
  color: #94a3b8;
  font-size: 10px;
}

.submit-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  width: 100%;
  height: 50px;
  padding: 0 20px;
  border: 0;
  border-radius: 9px;
  color: #fff;
  font-family: inherit;
  font-size: 13px;
  font-weight: 900;
  background: linear-gradient(135deg, #6d28d9, #e11d48);
  box-shadow: 0 14px 28px rgba(124, 58, 237, 0.23);
  transition: transform 150ms ease, box-shadow 150ms ease, opacity 150ms ease;
}

.submit-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 18px 32px rgba(225, 29, 72, 0.25);
}

.submit-button:disabled {
  cursor: wait;
  opacity: 0.62;
}

.spinner {
  width: 17px;
  height: 17px;
  animation: spin 750ms linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.login-link {
  margin: 22px 0 0;
  color: #64748b;
  font-size: 12px;
  text-align: center;
}

.login-link a {
  margin-left: 7px;
  color: #6d28d9;
  font-weight: 900;
  text-decoration: none;
}

.login-link a:hover,
.brand-link:hover {
  text-decoration: underline;
  text-underline-offset: 3px;
}

@media (max-width: 1050px) {
  .signup-shell {
    grid-template-columns: minmax(330px, 0.72fr) minmax(520px, 1.28fr);
  }
  .signup-intro {
    padding: 38px 34px 32px;
  }
  .intro-copy {
    margin-top: 56px;
  }
  .benefit-list li:nth-child(3) {
    display: none;
  }
  .signup-form-area {
    padding-right: 38px;
    padding-left: 38px;
  }
}
@media (max-width: 860px) {
  .signup-page {
    padding: 0;
    background: #fff;
  }
  .signup-shell {
    display: block;
    min-height: 100vh;
    min-height: 100dvh;
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }
  .signup-intro {
    display: none;
  }
  .signup-form-area {
    width: min(590px, 100%);
    padding: 44px 32px;
  }
  .mobile-brand {
    display: inline-flex;
  }
}
@media (max-width: 560px) {
  .signup-form-area {
    padding: max(30px, env(safe-area-inset-top)) max(20px, env(safe-area-inset-right)) max(36px, env(safe-area-inset-bottom)) max(20px, env(safe-area-inset-left));
  }
  .mobile-brand {
    margin-bottom: 28px;
  }
  .form-header {
    margin-bottom: 24px;
  }
  .form-header h2 {
    font-size: 27px;
  }
  .form-grid {
    grid-template-columns: 1fr;
  }
  .field-wide {
    grid-column: auto;
  }
  .input-action-row {
    grid-template-columns: minmax(0, 1fr) 92px;
  }
}
@media (max-width: 360px) {
  .signup-form-area {
    padding-right: max(16px, env(safe-area-inset-right));
    padding-left: max(16px, env(safe-area-inset-left));
  }
  .input-action-row {
    grid-template-columns: minmax(0, 1fr);
  }
  .input-action-row button {
    width: 100%;
  }
}
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
  }
}`],
})
export class PageSignupComponent implements OnInit {
    public form: any = {
        name: '',
        username: '',
        email: '',
        mobile: '',
        password: '',
        passwordConfirm: '',
        agreed: false,
    };

    public submitting: boolean = false;
    public checkingUsername: boolean = false;
    public usernameCheckStatus: string = 'idle';
    public usernameCheckMessage: string = '';
    public checkedUsername: string = '';
    public showPassword: boolean = false;
    public showPasswordConfirm: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const authenticated = await this.service.auth.check();
        if (authenticated) location.href = "/";
    }

    public normalizeUsername() {
        this.form.username = (this.form.username || '')
            .toLowerCase()
            .replace(/[^a-z0-9_]/g, '')
            .slice(0, 20);
        this.usernameCheckStatus = 'idle';
        this.usernameCheckMessage = '';
        this.checkedUsername = '';
    }

    public async checkUsername() {
        const username = (this.form.username || '').trim().toLowerCase();
        if (!/^[a-z0-9_]{4,20}$/.test(username)) {
            this.usernameCheckStatus = 'error';
            this.usernameCheckMessage = '영문 소문자, 숫자, 밑줄로 4~20자 입력해주세요.';
            await this.service.render();
            return;
        }
        if (this.checkingUsername) return;

        this.checkingUsername = true;
        this.usernameCheckStatus = 'idle';
        await this.service.render();

        const { code, data } = await wiz.call("check_username", { username });
        this.checkingUsername = false;

        if (code === 200) {
            this.checkedUsername = username;
            this.usernameCheckStatus = data.available ? 'success' : 'error';
            this.usernameCheckMessage = data.message;
        } else {
            this.checkedUsername = '';
            this.usernameCheckStatus = 'error';
            this.usernameCheckMessage = data?.message || data || '아이디 중복을 확인하지 못했습니다.';
        }
        await this.service.render();
    }

    public passwordStrength() {
        const password = this.form.password || '';
        let score = 0;
        if (password.length >= 8) score += 1;
        if (/[A-Za-z]/.test(password) && /\d/.test(password)) score += 1;
        if (/[^A-Za-z0-9]/.test(password) || password.length >= 12) score += 1;
        return score;
    }

    public strengthText() {
        const labels = ['매우 약함', '보통', '안전', '매우 안전'];
        return labels[this.passwordStrength()];
    }

    public passwordMatches() {
        return !!this.form.passwordConfirm && this.form.password === this.form.passwordConfirm;
    }

    public async register() {
        const name = (this.form.name || '').trim();
        const username = (this.form.username || '').trim().toLowerCase();
        const email = (this.form.email || '').trim().toLowerCase();
        const mobile = (this.form.mobile || '').trim();

        if (name.length < 2 || name.length > 50) {
            await this.service.modal.error("이름은 2~50자로 입력해주세요.");
            return;
        }
        if (!/^[a-z0-9_]{4,20}$/.test(username)) {
            await this.service.modal.error("아이디는 영문 소문자, 숫자, 밑줄로 4~20자 입력해주세요.");
            return;
        }
        if (this.usernameCheckStatus !== 'success' || this.checkedUsername !== username) {
            await this.service.modal.error("아이디 중복 확인을 완료해주세요.");
            return;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            await this.service.modal.error("올바른 이메일 주소를 입력해주세요.");
            return;
        }
        if (mobile.length > 20) {
            await this.service.modal.error("연락처는 20자 이내로 입력해주세요.");
            return;
        }
        if (this.form.password.length < 8 || !/[A-Za-z]/.test(this.form.password) || !/\d/.test(this.form.password)) {
            await this.service.modal.error("비밀번호는 영문과 숫자를 포함해 8자 이상 입력해주세요.");
            return;
        }
        if (!this.passwordMatches()) {
            await this.service.modal.error("비밀번호 확인이 일치하지 않습니다.");
            return;
        }
        if (!this.form.agreed) {
            await this.service.modal.error("서비스 이용 및 개인정보 처리 안내에 동의해주세요.");
            return;
        }
        if (this.submitting) return;

        this.form.name = name;
        this.form.username = username;
        this.form.email = email;
        this.form.mobile = mobile;
        this.submitting = true;
        await this.service.render();

        const { code, data } = await wiz.call("register", {
            name,
            username,
            email,
            mobile,
            password: this.form.password,
            passwordConfirm: this.form.passwordConfirm,
            agreed: this.form.agreed,
        });

        if (code === 200) {
            location.href = "/dashboard";
            return;
        }

        this.submitting = false;
        await this.service.modal.error(data?.message || data || "회원가입에 실패했습니다.");
        await this.service.render();
    }
}

export default PageSignupComponent;